<template>
    <div class="orderDetails">
        <!-- 头部 -->
        <div class="orderHeader">
            <div class="header-left" @click="back">
              <span class="iconfont iconzuojiantou"></span>
            </div>
            <div class="header-center">
              <p>订单详情</p>
            </div>
            <div class="header-right" @click="toHome">
              <span class="iconfont iconshouye"></span>
            </div>
        </div>
        <div style="height:40px"></div>

        <!-- 订单详情 -->
        <div class="orderOut no-show" v-show="!showLoading">
          <p class="orderTime">下单时间：{{Data.CreateDate}}</p>
          <div class="orderInner">
              <div class="innerHeader">
                  <span class='order-status-tips'>{{Data.Status}}</span>
                  <div class="headerText">单号：{{Data.BillCode}}</div>
              </div>
              <div class="innerContent">
                <p>预约服务项目：{{Data.ServiceName}}</p>
                <!-- <p v-if='!!item.StartTime && item.OrderType!="合作公司"'>服务时间：{{item.StartTime}}</p> -->
                <!-- <p>数量：{{Data.Qty}}（{{Data.Price}}{{Data.Unit}}）</p> -->
                <p>数量：{{Data.Qty}}</p>
                <p>金额：￥{{Data.Amount}}</p>
                <p v-if="Data.CustomerRemarks">备注：{{Data.CustomerRemarks}}</p>
              </div>
          </div>
        </div>

        <!-- 地址信息 -->
        <div class="addressOut no-show" v-show="!showLoading">
            <p class="addressTitle">地址信息</p>
            <div class="addressInner">
                <p>{{Data.CustomerName}} {{Data.CustomerPhone}}</p>
                <p>{{Data.CustomerAddress}}</p>
            </div>
        </div>

        <!-- 派单信息 -->
        <div class="allService" v-if="ListAssign.length > 0">
          <div class="serviceOut" v-for="(item,index) in ListAssign" :key="index">
            <p class="serviceTitle">派单信息</p>
            <div class="serviceInner">
              <p>服务时间：{{item.WorkDate}} {{item.WorkTimesName}}</p>
              <p>家政员：{{item.EmployeeName}} {{item.EmployeePhone}}</p>
              <p>工时单价：{{item.Price}}</p>
              <p>金额: {{item.Amount}}</p>
              <span class='info-tips' v-if="item.IsReturn == 1">已回单</span>
            </div>
          </div>
        </div>

        <!-- 按钮 -->
        <div class="button no-show" v-show="!showLoading">
          <div class="payment" v-if="(Data.Status == '未接单' || '未回单' || '待付款') && Data.CanPayAmount > 0 && Data.Status != '已取消'" @click="toWxPay">微信支付</div>
          <div class="cancel" v-if="Data.CanCancel == 1" @click="toCancel">取消订单</div>
        </div>
        
    </div>
</template>

<script>
import { Toast } from 'vant'
import { Dialog } from 'vant'
export default {
    data () {
        return {
          Data:{},
          ListAssign:[],
          showLoading: true
        }
    },
    created () {
      let id = this.$route.query.Id
      // this.showLoading = true
      Toast.loading({
        message: '加载中...'
      })
      this.$axios.get('/api/DjOrder/GetOrderInfoDetail',{
          params: {
            Id:id
          }
      }).then(res => {
        this.showLoading = false
         this.Data = res.data
         this.ListAssign = res.data.ListAssign
         this.ListAssign.forEach(i => {
           if (i.IsReturn == 1) {
               i.WorkTimesName = i.rWorkTimesName
               i.Amount = i.rAmount
           }
         })
         Toast.clear()
        // console.log(this.Data)
      })
    },
    methods: {
      back () {
          this.$router.back()
      },
      toHome () {
         this.$router.push('/')
      },
      toWxPay () {
        let id = this.$route.query.Id
        window.location.href = '/wxpay/JzOrderPay.html?Id=' + id
      },
      toCancel () {
        
        Dialog.confirm({
        title: '取消订单',
        message: '确定要取消该订单吗？'
        }).then(() => {
           //发送取消
           let id = this.$route.query.Id
           this.$axios.post('/api/DjOrder/CancelOrder',{
             Id:id
           }).then(res => {
             if(res.data.type == 1){
                Toast.success({message: '取消成功'})
                //this.$router.go(0)
                location.reload()
             }else{
                Toast.fail({message: '操作失败'})
             }
           })
       

        }).catch(() => {
        
        });
      }
      
    }
    
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.no-show{
  // display: none
}
.orderDetails
  width: 100%
  height: 100vh
  background: rgb(240, 240, 240)
  .orderHeader
   position: fixed
   z-index: 100
   left: 0
   right: 0
   top: 0
   display: flex
   justify-content: space-between
   width: 100%
   height: 40px
   align-items: center
   background-color: green
   color: white
   font-weight: bold
   .header-left
      margin-left: 8px
      height: 100%
      width: 40px
      display: flex
      align-items: center
    .header-right
      margin-right: 8px
      width: 40px
      height: 100%
      display: flex
      align-items: center
      justify-content: flex-end
      .iconshouye
        font-size: 20px
  .orderOut
      width: 100%
      padding: 10px 6px
      box-sizing: border-box
      // margin-top: 40px
      .orderTime
        font-size: 13px
        margin-bottom: 4px
        color: #999999
      .orderInner
        width: 100%
        border: 1px solid #ddd
        border-radius: 4px
        overflow: hidden
        background-color: white
        .innerHeader
          display: flex
          justify-content: space-between
          align-items: center
          border-bottom: 1px solid #ddd
          font-size: 13px
          padding: 6px 6px
          color: #999
          .order-status-tips
            background-color: #578EBE
            color: #fff
            height: 20px
            width: 56px
            margin-left: -6px
            font-size: 12px
            line-height: 20px
            text-align: center
        .innerContent
          padding: 8px
          position: relative
          min-height: 60px
          &>p
            line-height: 24px
            font-size: 13px
  .addressOut
    width: 100%
    padding: 10px 6px
    box-sizing: border-box
    .addressTitle
      font-size: 13px
      margin-bottom: 4px
      color: #999999
    .addressInner
      width: 100%
      border: 1px solid #ddd
      border-radius: 4px
      overflow: hidden
      background-color: white
      padding: 8px
      box-sizing: border-box
      &>p
        line-height: 24px
        font-size: 13px
  .serviceOut
    width: 100%
    padding: 10px 6px
    box-sizing: border-box
    background: rgb(240, 240, 240)
    .serviceTitle
      font-size: 13px
      margin-bottom: 4px
      color: #999999
    .serviceInner
      position: relative 
      width: 100%
      border: 1px solid #ddd
      border-radius: 4px
      overflow: hidden
      background-color: white
      padding: 8px
      box-sizing: border-box
      .info-tips
        position: absolute
        top: 6px
        right: 8px
        width: 60px
        padding: 4px
        color: #fff
        background-color: #578ebe
        text-align: center
        font-size: 14px
      &>p
        line-height: 24px
        font-size: 13px
  .button
    width: 100%
    background: rgb(240, 240, 240)
    padding-bottom: 10px
    &>div
     width: 90%
     height: 36px
     line-height: 36px
     text-align: center
     margin: auto
     border: 1px solid 
     margin-bottom: 10px
     border-radius: 26px
     background: #093
     color: #fff

          

</style>



// WEBPACK FOOTER //
// src/pages/OrderList/OrderDetails.vue